import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  editErrorInvoices,
  listNotificationPropertiesErrorInvoices,
  listTypeInvoiceErrorInvoices,
  resetEditErrorInvoices,
  resetListNotificationPropertiesErrorInvoices,
  resetListTypeInvoiceErrorInvoices,
} from "store/actions";
import * as yup from "yup";
import SearchInvoice from "./SearchInvoice";
import "./style.scss";
import {
  KyHieuMauHoaDonList,
  MODE,
  convertDate,
  errorInvoicesLoaiThongBao,
} from "./utils";
const DetailDataModal = props => {
  const { isOpen, toggle, detailData } = props;

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["errorInvoice"]);
  const { t: tt } = useTranslation(["requestInvoiceCode"]);
  const { addToast } = useToasts();

  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    loadingListTypeInvoice,
    errorListTypeInvoice,
    listTypeInvoice: errorInvoicesListTypeInvoice,

    loadingListNotificationProperties,
    errorListNotificationProperties,
    listNotificationProperties: errorInvoicesListNotificationProperties,

    loadingEdit,
    errorEdit,
    edit: errorInvoicesEdit,
  } = errorInvoices;

  useEffect(() => {
    if (!isOpen) {
      reset();
    }
    if (isOpen && errorInvoicesListTypeInvoice) {
      //   reset();
      const ladhddt = errorInvoicesListTypeInvoice.items.find(
        item => item.id === detailData.ladhddt
      );
      if (ladhddt) {
        setValue("loai_hoa_don", {
          value: ladhddt.id,
          label: ladhddt.value,
        });
      }
      const loai_thong_bao = errorInvoicesLoaiThongBao.find(
        item => Number(item.value) === Number(detailData.loai)
      );
      if (loai_thong_bao) {
        setValue("loai_thong_bao", {
          value: loai_thong_bao.value,
          label: loai_thong_bao.label,
        });
      }
      if (detailData.so) {
        setValue("so_thong_bao", detailData.so);
      }
      if (detailData.ntbccqt) {
        setValue("ngay_thong_bao", [new Date(detailData.ntbccqt)]);
      }

      // lines
      // id_invoice :item.KHHDon,khhdon ,ly_do ,ma_cqt_cap , so_hoa_don ,tchat_thong_bao
      // ngay_lap_hdon
      // tchat_thong_bao ,khmhdon

      checkThongBaoHandler();
      checkLoaiHoaDonHandler();
      let lines = [];
      let listSearchInvoice = [];
      if (detailData.dshdon && detailData.dshdon.length > 0) {
        lines = detailData.dshdon.map(item => {
          const tchatThongbao =
            errorInvoicesListNotificationProperties.items.find(
              f => Number(f.id) === Number(item.TCTBao)
            );
          const khmhdon = KyHieuMauHoaDonList.find(
            f => Number(f.value) === Number(item.KHMSHDon)
          );
          return {
            id_invoice: item.Id,
            khhdon: item.KHHDon,
            ly_do: item.LDo,
            ma_cqt_cap: item.MCCQT,
            so_hoa_don: item.SHDon,
            ngay_lap_hdon: [new Date(item.Ngay)],
            tchat_thong_bao: {
              value: tchatThongbao.id,
              label: tchatThongbao.value,
            },
            khmhdon: khmhdon,
          };
        });
        listSearchInvoice = detailData.dshdon.map(item => {
          return {
            id: item.Id,
            mccqt: item.MCCQT,
            nban_mst: item.MCCQT,
            ttchung_khmshdon: item.KHMSHDon,
            ttchung_khhdon: item.KHHDon,
            ttchung_shdon: item.SHDon,
            ttchung_nlap: new Date(item.Ngay).getTime() / 1000,
          };
        });
        setValue("lines", lines, { shouldValidate: true });
        if (Number(ladhddt.id) === 1) {
          setDataSearchInvoice(listSearchInvoice);
        }
      } else {
        setDataSearchInvoice([]);
      }
    } else {
    }
  }, [isOpen, errorInvoicesListTypeInvoice]);

  // Search Invoice Modal
  const [dataSearchInvoice, setDataSearchInvoice] = useState([]);
  const [searchInvoiceModal, setSearchInvoiceModal] = useState(false);
  const [displaySearchInvoice, setDisplaySearchInvoice] = useState(false);

  // Show / Hide Field Thông Báo
  const [displayThongBao, setDisplayThongBao] = useState(false);

  let schema = yup.object().shape({
    is_thong_bao: yup.boolean(),
    is_loai_hoa_don: yup.boolean(),
    loai_hoa_don: yup
      .object()
      .required(t("form.validate.select", { title: t("form.loai_hoa_don") })),
    loai_thong_bao: yup
      .object()
      .required(t("form.validate.select", { title: t("form.loai_thong_bao") })),
    so_thong_bao: yup.string().when("is_thong_bao", {
      is: true,
      then: yup
        .string()
        .required(
          t("form.validate.required", { title: t("form.so_thong_bao") })
        ),
    }),
    ngay_thong_bao: yup.array().when("is_thong_bao", {
      is: true,
      then: yup
        .array()
        .min(1, t("form.validate.select", { title: t("form.ngay_thong_bao") })),
    }),
    lines: yup.array().when("is_loai_hoa_don", {
      is: true,
      then: yup
        .array()
        .min(1, t("form.validate.least_one_line"))
        .of(
          yup.object().shape({
            id_invoice: yup.string().nullable(),
            ma_cqt_cap: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ma_cqt_cap") })
              ),
            khmhdon: yup
              .object()
              .required(
                t("form.validate.select", { title: t("form.khmhdon") })
              ),
            khhdon: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.khhdon") })
              ),
            // .max(6, t("form.validate.char_max", { max: 6 })),
            so_hoa_don: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.so_hoa_don") })
              )
              .matches(/^[0-9]+$/, t("form.validate.integer")),
            // .max(20, t("form.validate.integer_max", { max: 20 })),
            ngay_lap_hdon: yup
              .array()
              .min(
                1,
                t("form.validate.select", { title: t("form.ngay_lap_hdon") })
              ),
            tchat_thong_bao: yup.object().required(
              t("form.validate.select", {
                title: t("form.tchat_thong_bao"),
              })
            ),
            ly_do: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ly_do") })
              ),
          })
        ),
      otherwise: yup
        .array()
        .min(1, t("form.validate.least_one_line"))
        .of(
          yup.object().shape({
            ma_cqt_cap: yup.string(),
            khmhdon: yup
              .object()
              .required(
                t("form.validate.select", { title: t("form.khmhdon") })
              ),
            khhdon: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.khhdon") })
              ),
            // .max(6, t("form.validate.char_max", { max: 6 })),
            so_hoa_don: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.so_hoa_don") })
              )
              .matches(/^[0-9]+$/, t("form.validate.integer")),
            // .max(20, t("form.validate.integer_max", { max: 20 })),
            ngay_lap_hdon: yup
              .array()
              .min(
                1,
                t("form.validate.select", { title: t("form.ngay_lap_hdon") })
              ),
            tchat_thong_bao: yup.object().required(
              t("form.validate.select", {
                title: t("form.tchat_thong_bao"),
              })
            ),
            ly_do: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ly_do") })
              ),
          })
        ),
    }),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      is_thong_bao: false,
      is_loai_hoa_don: true,
      loai_hoa_don: undefined,
      loai_thong_bao: undefined,
      so_thong_bao: "",
      ngay_thong_bao: [],
      lines: [],
    },
  });

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "lines", // unique name for your Field Array
      keyName: "key", // keyName: "id", default to "id", you can change the key name
    }
  );

  // Set Default Values
  useEffect(() => {
    const findLoaiThongBao = errorInvoicesLoaiThongBao.find(
      item => item.key === "type1"
    );
    if (findLoaiThongBao) {
      setValue("loai_thong_bao", {
        value: findLoaiThongBao.value,
        label: findLoaiThongBao.label,
      });
    }
  }, []);

  // Get List Data For Select
  useEffect(() => {
    dispatch(listTypeInvoiceErrorInvoices());
    dispatch(listNotificationPropertiesErrorInvoices());
    return () => {
      dispatch(resetListTypeInvoiceErrorInvoices());
      dispatch(resetListNotificationPropertiesErrorInvoices());
    };
  }, [dispatch]);

  // Error Dispatch
  useEffect(() => {
    if (errorListTypeInvoice) {
      addToast(
        formConvertErrorMessage(
          errorListTypeInvoice.message ||
            t("message.list", {
              target: t("type_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListTypeInvoiceErrorInvoices());
    }

    if (errorListNotificationProperties) {
      addToast(
        formConvertErrorMessage(
          errorListNotificationProperties.message ||
            t("message.list", {
              target: t("notification_properties"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListNotificationPropertiesErrorInvoices());
    }

    if (errorEdit) {
      addToast(
        formConvertErrorMessage(
          errorEdit.message ||
            t("message.create", {
              target: t("error_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        { appearance: "error", autoDismiss: true }
      );
      if (errorEdit.code === 422 && errorEdit.fields.length > 0) {
        errorEdit.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, {
            type: "manual",
            message: formConvertErrorMessage(item.message, t),
          });
        });
      }
      dispatch(resetEditErrorInvoices());
    }
  }, [
    addToast,
    dispatch,
    errorEdit,
    errorListNotificationProperties,
    errorListTypeInvoice,
    setError,
    t,
  ]);

  const toggleSearchInvoiceModal = (action = "") => {
    setSearchInvoiceModal(!searchInvoiceModal);
    switch (action) {
      case "change":
        // Clear Main Template Version After Selected New List
        // setValue("main_template_version_id", "", { shouldValidate: true });
        break;
      default:
        break;
    }
  };

  const checkThongBaoHandler = () => {
    const valueLoaiThongBao = getValues("loai_thong_bao");
    if (valueLoaiThongBao !== undefined) {
      switch (valueLoaiThongBao.value) {
        case "1":
          setDisplayThongBao(false);
          setValue("is_thong_bao", false);
          break;
        case "2":
          setDisplayThongBao(true);
          setValue("is_thong_bao", true);
          break;
        default:
          break;
      }
    }
  };

  const checkLoaiHoaDonHandler = () => {
    const valueLoaiHoaDon = getValues("loai_hoa_don");

    setValue("lines", [], { shouldValidate: true });

    if (valueLoaiHoaDon !== undefined) {
      switch (Number(valueLoaiHoaDon.value)) {
        case 1:
          setValue("is_loai_hoa_don", true);
          setDisplaySearchInvoice(true);
          break;
        default:
          addNewLine();
          setValue("is_loai_hoa_don", false);
          setDisplaySearchInvoice(false);
          break;
      }
    }
  };

  const addNewLine = (dataReplace = null) => {
    append(
      dataReplace || {
        id_invoice: null,
        ma_cqt_cap: "",
        khmhdon: undefined,
        khhdon: "",
        so_hoa_don: "",
        ngay_lap_hdon: [],
        tchat_thong_bao: undefined,
        ly_do: "",
      }
    );
  };

  const onSubmit = values => {
    // toggleTypeSignModal();
    // setTransferData(values);
    callApi(values);
  };

  const removeDataSearchInvoice = index => {
    const lineMustRemove = getValues(`lines.${index}`);
    const filterDataSearchInvoice = dataSearchInvoice.filter(
      item => item.id !== lineMustRemove.id_invoice
    );
    setDataSearchInvoice(filterDataSearchInvoice);
  };

  const callApi = values => {
    // const values = transferData;
    const dataCreate = {
      loai: values.loai_thong_bao.value,
      ladhddt: values.loai_hoa_don.value,
      dshdon: [],
      // ntbccqt: "",
      // so: "",
      // dshdon: [
      //   {
      //     LDo: "Hủy",
      //     Ngay: "2022-01-12 14:21:02",
      //     SHDon: "2",
      //     KHHDon: "C22TXX",
      //     TCTBao: 1,
      //     LADHDDT: 1,
      //     MCQTCap: "00363514E4EBC54125B95D763ED4B3A947",
      //     KHMSHDon: "1",
      //     ID: null,
      //   },
      // ],
    };
    if (getValues("is_thong_bao")) {
      dataCreate["ntbccqt"] = convertDate(values.ngay_thong_bao[0], "date");
      dataCreate["so"] = Number(values.so_thong_bao);
    }

    dataCreate.dshdon = values.lines.map(item => {
      return {
        LDo: item.ly_do,
        Ngay: convertDate(item.ngay_lap_hdon[0], "date"),
        SHDon: Number(item.so_hoa_don),
        TCTBao: item.tchat_thong_bao.value,
        LADHDDT: values.loai_hoa_don.value,
        MCQTCap: item.ma_cqt_cap,
        KHHDon: item.khhdon,
        KHMSHDon: item.khmhdon.value,
        ID: item.id_invoice || null,
      };
    });
    dispatch(editErrorInvoices({ ...dataCreate }, detailData.id));
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Thông báo hóa đơn sai sót</Label>
        </ModalHeader>
        <ModalBody>
          <Row className="row-cols-1">
            {/* Modal START*/}
            <Col>
              {/* Search Invoice Modal */}
              <SearchInvoice
                bu_code={detailData?.bu_code}
                // dataDetail={dataSelectTemplates}
                isOpenModal={searchInvoiceModal}
                toggleModal={toggleSearchInvoiceModal}
                dataSearchInvoice={dataSearchInvoice}
                setDataSearchInvoice={setDataSearchInvoice}
                addNewLine={addNewLine}
              />
            </Col>
            {/* Modal E N D*/}
            <Col>
              <Card>
                <CardBody>
                  <Row className="row-cols-1 row-cols-md-2">
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="loai_hoa_don">
                          {t("form.loai_hoa_don")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="loai_hoa_don"
                          render={({ field }) => (
                            <Select
                              {...field}
                              isDisabled={detailData.mode === MODE.VIEW}
                              placeholder={t("placeholder.select", {
                                title: t("form.loai_hoa_don"),
                              })}
                              options={
                                errorInvoicesListTypeInvoice &&
                                errorInvoicesListTypeInvoice.items &&
                                errorInvoicesListTypeInvoice.items.length > 0
                                  ? errorInvoicesListTypeInvoice.items.map(
                                      item => ({
                                        value: String(item.id),
                                        label: item.value,
                                      })
                                    )
                                  : []
                              }
                              onChange={data => {
                                field.onChange(data);
                                checkLoaiHoaDonHandler();
                              }}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                        {errors.loai_hoa_don && (
                          <MessageFormValidate
                            error={errors.loai_hoa_don.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="loai_thong_bao">
                          {t("form.loai_thong_bao")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="loai_thong_bao"
                          render={({ field }) => (
                            <Select
                              {...field}
                              isDisabled={detailData.mode === MODE.VIEW}
                              placeholder={t("placeholder.select", {
                                title: t("form.loai_thong_bao"),
                              })}
                              options={
                                errorInvoicesLoaiThongBao &&
                                errorInvoicesLoaiThongBao.length > 0
                                  ? errorInvoicesLoaiThongBao.map(item => ({
                                      value: item.value,
                                      label: item.label,
                                    }))
                                  : []
                              }
                              onChange={data => {
                                field.onChange(data);
                                checkThongBaoHandler();
                              }}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                        {errors.loai_thong_bao && (
                          <MessageFormValidate
                            error={errors.loai_thong_bao.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                    {displayThongBao && (
                      <React.Fragment>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="so_thong_bao">
                              {t("form.so_thong_bao")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              disabled={detailData.mode === MODE.VIEW}
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "so_thong_bao"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("form.so_thong_bao"),
                              })}
                              {...register("so_thong_bao")}
                            />
                            {errors.so_thong_bao && (
                              <MessageFormValidate
                                error={errors.so_thong_bao.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="ngay_thong_bao">
                              {t("form.ngay_thong_bao")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Controller
                              control={control}
                              name="ngay_thong_bao"
                              render={({ field }) => (
                                <Flatpickr
                                  {...field}
                                  disabled={detailData.mode === MODE.VIEW}
                                  className="form-control d-block Flatpickr__Input"
                                  placeholder="DD/MM/YYYY"
                                  options={{
                                    altInput: true,
                                    altFormat: "d/m/Y",
                                    dateFormat: "d/m/Y",
                                    locale: {
                                      ...Vietnamese,
                                      firstDayOfWeek: 1,
                                    },
                                  }}
                                  onChange={date => {
                                    field.onChange(date);
                                  }}
                                />
                              )}
                            />
                            {errors.ngay_thong_bao && (
                              <MessageFormValidate
                                error={errors.ngay_thong_bao.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                  {displaySearchInvoice && detailData.mode === MODE.EDIT && (
                    <Row className="mb-2">
                      <Col>
                        <button
                          type="button"
                          className="btn btn-primary btn-label"
                          onClick={() => {
                            toggleSearchInvoiceModal();
                          }}
                        >
                          <i className="fas fa-search-plus label-icon" />
                          {t("form.search_invoice")}
                        </button>
                      </Col>
                    </Row>
                  )}
                  <div className="custom-table-border">
                    <Table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "20px" }}>
                            STT
                          </th>
                          <th>Mã CQT cấp</th>
                          <th>Ký hiệu mẫu hóa đơn và ký hiệu hóa đơn</th>
                          <th>Số hóa đơn điện tử</th>
                          <th>Ngày lập hóa đơn</th>
                          <th>Tính chất thông báo</th>
                          <th>Lý do</th>
                          <th style={{ width: "20px" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.map((field, index) => {
                          return (
                            <tr key={field.key}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  disabled={
                                    displaySearchInvoice ||
                                    detailData.mode === MODE.VIEW
                                  }
                                  type="text"
                                  className={`form-control ${formValidate(
                                    errors,
                                    touchedFields,
                                    `lines.${index}.ma_cqt_cap`
                                  )}`}
                                  placeholder={t("placeholder.enter", {
                                    title: t("form.ma_cqt_cap"),
                                  })}
                                  {...register(`lines.${index}.ma_cqt_cap`)}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].ma_cqt_cap && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].ma_cqt_cap.message
                                      }
                                    />
                                  )}
                              </td>
                              <td>
                                <Row className="row-cols-1 row-cols-lg-2">
                                  <Col>
                                    <Controller
                                      control={control}
                                      name={`lines.${index}.khmhdon`}
                                      render={({ field }) => (
                                        <CreatableSelect
                                          {...field}
                                          isDisabled={
                                            displaySearchInvoice ||
                                            detailData.mode === MODE.VIEW
                                          }
                                          placeholder={t("placeholder.select", {
                                            title: t("form.khmhdon"),
                                          })}
                                          options={
                                            KyHieuMauHoaDonList &&
                                            KyHieuMauHoaDonList.length > 0
                                              ? KyHieuMauHoaDonList.map(
                                                  item => ({
                                                    value: item.value,
                                                    label: item.label,
                                                  })
                                                )
                                              : []
                                          }
                                          classNamePrefix="select2-selection"
                                        />
                                      )}
                                    />
                                    {errors.lines &&
                                      errors.lines[index] &&
                                      errors.lines[index].khmhdon && (
                                        <MessageFormValidate
                                          error={
                                            errors.lines[index].khmhdon.message
                                          }
                                        />
                                      )}
                                  </Col>
                                  <Col>
                                    <Controller
                                      control={control}
                                      name={`lines.${index}.khhdon`}
                                      render={({ field }) => (
                                        <input
                                          {...field}
                                          disabled={
                                            displaySearchInvoice ||
                                            detailData.mode === MODE.VIEW
                                          }
                                          type="text"
                                          className={`form-control ${formValidate(
                                            errors,
                                            touchedFields,
                                            `lines.${index}.khhdon`
                                          )}`}
                                          onChange={data => {
                                            field.onChange(
                                              data.target.value.toUpperCase()
                                            );
                                          }}
                                          placeholder={t("placeholder.enter", {
                                            title: t("form.khhdon"),
                                          })}
                                        />
                                      )}
                                    />
                                    {errors.lines &&
                                      errors.lines[index] &&
                                      errors.lines[index].khhdon && (
                                        <MessageFormValidate
                                          error={
                                            errors.lines[index].khhdon.message
                                          }
                                        />
                                      )}
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <input
                                  disabled={
                                    displaySearchInvoice ||
                                    detailData.mode === MODE.VIEW
                                  }
                                  type="number"
                                  className={`form-control ${formValidate(
                                    errors,
                                    touchedFields,
                                    `lines.${index}.so_hoa_don`
                                  )}`}
                                  placeholder={t("placeholder.enter", {
                                    title: t("form.so_hoa_don"),
                                  })}
                                  {...register(`lines.${index}.so_hoa_don`)}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].so_hoa_don && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].so_hoa_don.message
                                      }
                                    />
                                  )}
                              </td>
                              <td>
                                <Controller
                                  control={control}
                                  name={`lines.${index}.ngay_lap_hdon`}
                                  render={({ field }) => (
                                    <Flatpickr
                                      {...field}
                                      disabled={
                                        displaySearchInvoice ||
                                        detailData.mode === MODE.VIEW
                                      }
                                      className="form-control d-block Flatpickr__Input"
                                      placeholder="DD/MM/YYYY"
                                      options={{
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        dateFormat: "d/m/Y",
                                        locale: {
                                          ...Vietnamese,
                                          firstDayOfWeek: 1,
                                        },
                                      }}
                                      onChange={date => {
                                        field.onChange(date);
                                      }}
                                    />
                                  )}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].ngay_lap_hdon && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].ngay_lap_hdon
                                          .message
                                      }
                                    />
                                  )}
                              </td>
                              <td>
                                <Controller
                                  control={control}
                                  name={`lines.${index}.tchat_thong_bao`}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      placeholder={t("placeholder.select", {
                                        title: t("form.tchat_thong_bao"),
                                      })}
                                      isDisabled={
                                        detailData?.mode === MODE.VIEW
                                      }
                                      options={
                                        errorInvoicesListNotificationProperties &&
                                        errorInvoicesListNotificationProperties.items &&
                                        errorInvoicesListNotificationProperties
                                          .items.length > 0
                                          ? errorInvoicesListNotificationProperties.items.map(
                                              item => ({
                                                value: item.id,
                                                label: item.value,
                                              })
                                            )
                                          : []
                                      }
                                      classNamePrefix="select2-selection"
                                    />
                                  )}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].tchat_thong_bao && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].tchat_thong_bao
                                          .message
                                      }
                                    />
                                  )}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  disabled={detailData?.mode === MODE.VIEW}
                                  className={`form-control ${formValidate(
                                    errors,
                                    touchedFields,
                                    `lines.${index}.ly_do`
                                  )}`}
                                  placeholder={t("placeholder.enter", {
                                    title: t("form.ly_do"),
                                  })}
                                  {...register(`lines.${index}.ly_do`)}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].ly_do && (
                                    <MessageFormValidate
                                      error={errors.lines[index].ly_do.message}
                                    />
                                  )}
                              </td>
                              <td>
                                <React.Fragment>
                                  {detailData?.mode === MODE.EDIT && (
                                    <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                                      {displaySearchInvoice ? (
                                        <React.Fragment>
                                          {fields.length >= 1 && (
                                            <i
                                              onClick={() => {
                                                removeDataSearchInvoice(index);
                                                remove(index);
                                              }}
                                              className="fas fa-trash fa-lg text-danger"
                                              style={{ cursor: "pointer" }}
                                            />
                                          )}
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          {fields.length > 1 && (
                                            <i
                                              onClick={() => {
                                                remove(index);
                                              }}
                                              className="fas fa-trash fa-lg text-danger"
                                              style={{ cursor: "pointer" }}
                                            />
                                          )}

                                          {index === fields.length - 1 && (
                                            <i
                                              onClick={addNewLine}
                                              className="fas fa-plus fa-lg text-success"
                                              style={{ cursor: "pointer" }}
                                            ></i>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </div>
                                  )}
                                </React.Fragment>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    {errors.lines && (
                      <MessageFormValidate error={errors.lines.message} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          {detailData?.mode === MODE.EDIT && (
            <Button
              color="primary"
              className="btn-label"
              type="button"
              onClick={() => {
                handleSubmit(onSubmit)();
              }}
              disabled={loadingEdit}
            >
              <i className="far fa-save label-icon"></i>
              Cập nhật
            </Button>
          )}
        </ModalFooter>
      </div>
    </Modal>
  );
};

DetailDataModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  detailData: PropTypes.any,
};

export default DetailDataModal;
